<script lang="ts" setup>
import NewsEditItem from '@/components/admin/NewsEditItem.vue'
import { NewsItem } from '@/helper/Types'

defineProps<{
  news: NewsItem[]
}>()

const emit = defineEmits<{
  (e: 'delete', news: NewsItem): void
  (e: 'save', news: NewsItem): void
}>()
</script>

<template>
  <div class="news-list">
    <div class="fTable card">
      <div v-if="news.length > 0" class="fTable__tr has--th">
        <div class="fTable__th column">
          News
        </div>
        <div class="fTable__th column">
          Date
        </div>
        <div class="fTable__th column" />
      </div>

      <div v-if="news.length > 0">
        <NewsEditItem
          v-for="item in news"
          :key="item.id"
          :item="item"
          @delete="n => emit('delete', n)"
          @save="n => emit('save', n)"
        />
      </div>
      <div v-else class="info-row">
        No news available
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.column {
  &:not(:first-child) {
    justify-content: flex-end;
    flex-basis: 20%;
  }
}

.info-row {
  text-align: center;
  margin: rem-calc(24);
  color: $textColorLight;
}
</style>
